import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PhotoModal from './PhotoModal';
import AgentContactModal from './AgentContactModal';
import analyticsService from '../services/analyticsService';

const PhotoModalWithAgent = ({ listing, onClose, isMobile }) => {
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [selectedAgentKey, setSelectedAgentKey] = useState(null);

  // Handle agent click to open contact modal
  const handleAgentClick = (e, agentKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (agentKey) {
      setSelectedAgentKey(agentKey);
      setShowAgentModal(true);
      
      // Track analytics
      analyticsService.trackContact('Agent Contact Modal Opened', agentKey, {
        source: 'Photo Modal',
        agentType: 'Listing Agent'
      });
    }
  };

  // Handle host click to open contact modal
  const handleHostClick = (e, hostKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (hostKey) {
      setSelectedAgentKey(hostKey);
      setShowAgentModal(true);
      
      // Track analytics
      analyticsService.trackContact('Agent Contact Modal Opened', hostKey, {
        source: 'Photo Modal',
        agentType: 'Host Agent'
      });
    }
  };

  return (
    <>
      <PhotoModal 
        listing={listing} 
        onClose={onClose} 
        isMobile={isMobile}
        onAgentClick={handleAgentClick}
        onHostClick={handleHostClick}
      />
      {showAgentModal && ReactDOM.createPortal(
        <AgentContactModal
          show={showAgentModal}
          onClose={() => setShowAgentModal(false)}
          memberKey={selectedAgentKey}
          className="photo-modal-agent-contact"
        />,
        document.body
      )}
    </>
  );
};

export default PhotoModalWithAgent;
